import { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Col } from 'react-bootstrap';
import FormContainer from '../components/FormContainer';
import CheckoutSteps from '../components/CheckoutSteps';
import { savePaymentMethod } from '../slices/cartSlice';
import Meta from "../components/Meta";
import { trackAddPaymentInfo } from '../utils/gaAnalytics';

const PaymentScreen = () => {
    const [paymentMethod, setPaymentMethod] = useState('CreditCard');

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const cart = useSelector((state) => state.cart);
    const { shippingAddress } = cart;

    useEffect(() => {
        if (!shippingAddress) {
            navigate('/shipping');
        }
    }, [shippingAddress, navigate]);

    const submitHandler = (e) => {
        e.preventDefault();
        dispatch(savePaymentMethod(paymentMethod));
        try {
            const cartItems = cart.cartItems || [];
            const totalValue = cart.totalPrice || 0;
            trackAddPaymentInfo(cartItems, totalValue, paymentMethod);
        } catch(_) {}
        navigate('/placeorder');
    }

    return (<>
        <Meta
            title='お支払い方法 | ふるぷら'
            description='お支払い方法の選択ページです。'
            robots='noindex, nofollow'
        />
        <FormContainer>
            <CheckoutSteps step1 step2 step3 />
            <h1 className="mt-3">お支払い方法</h1>
            <Form onSubmit={ submitHandler }>
                <Form.Group>
                    <Form.Label as='legend'>お支払い方法を選択する</Form.Label>
                    <Col>
                        <Form.Check
                            type="radio"
                            className="my-2"
                            label="Credit Card"
                            id="CreditCard"
                            name="paymentMethod"
                            value="CreditCard"
                            checked
                            onChange={(e) => setPaymentMethod(e.target.value)}
                        >
                        </Form.Check>
                    </Col>
                </Form.Group>

                <Button type="submit" variant="primary">
                    Continue
                </Button>
            </Form>
        </FormContainer>
    </>)
}

export default PaymentScreen;